import React from "react";
import { Message } from "semantic-ui-react";

const styleURLS = {
  alerts: {
    maxWidth: "400px",
    position: "fixed",
    top: "0",
    right: "20px",
    zIndex: "22222",
  },
};

function AlertMessage(props) {
  switch (props.type) {
    case "success":
      return (
        <Message success style={styleURLS.alerts}>
          <Message.Header>{props.messageHeader}</Message.Header>
          <p>{props.messageBody}</p>
        </Message>
      );
    case "warning":
      return (
        <Message warning style={styleURLS.alerts}>
          <Message.Header>{props.messageHeader}</Message.Header>
          <p>{props.messageBody}</p>
        </Message>
      );
    case "error":
      return (
        <Message error style={styleURLS.alerts}>
          <Message.Header>{props.messageHeader}</Message.Header>
          <p>{props.messageBody}</p>
        </Message>
      );
    case "info":
      return (
        <Message info style={styleURLS.alerts}>
          <Message.Header>{props.messageHeader}</Message.Header>
          <p>{props.messageBody}</p>
        </Message>
      );
    default:
      return (
        <Message hidden info style={styleURLS.alerts}>
          <Message.Header>{props.messageHeader}</Message.Header>
          <p>{props.messageBody}</p>
        </Message>
      );
  }
}

export default AlertMessage;
